<template>
  <div class="main">
    <div class="content">
      <div class="title">亲爱的会员，您好！</div>

      <div class="tips">{{ ERR }} <span @click="GoBack">返回首页</span></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ERR: "",
    };
  },
  methods: {
    GoBack() {
      this.$router.push("/");
    },
  },
  created() {
    if (this.$route.query.ERR) {
      this.ERR = this.$route.query.ERR;
    }
  },
};
</script>


<style lang="scss" scoped>
.main {
  background: #e9eded;
  width: 100vw;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  .content {
    width: 90vw;
    min-height: 90vh;
    background-color: #fff;
    border-top: 3px solid #4776e6;
    padding: 0 20px;
    box-sizing: border-box;
    .title {
      font-size: 24px;
      line-height: 30px;
      margin-top: 50px;
      padding-bottom: 25px;
      text-align: center;
    }
    .tips {
      line-height: 22px;
      font-size: 14px;
      text-align: center;
      span {
        font-size: 12px;
        color: #4776e6;
        cursor: pointer;
      }
    }
  }
}
</style>